module.exports = __webpack_public_path__ + "img/live_03.e8f7f222.png";